module.exports = __webpack_public_path__ + "img/5.1.95e78ffb.png";